import { SearchResponse } from '@algolia/client-search';
import { resourceFilterComponent, paginationComponent, filterKeywordSearch } from '.';
import { ISearchParams, SearchService } from '../algolia/SearchService';
import { SelectDropdown } from '../algolia/SelectDropdown';
import { SearchCount } from '../algolia/SearchCount';
import { FacetApplied } from '../algolia/FacetApplied';
import { IDefaultSearchResult, IFacet } from '../interface';
import { FacetSelect } from '../algolia/FacetSelect';
import { Pagination } from "../algolia/Pagination";
import { SearchKeyword } from '../algolia/SearchKeyword';
import {updateLanguageLinks} from "./languageSwitcher";

type TSearchFacets = 'post_type_label' | 'taxonomies.category' | 'taxonomies.topic';

const defaultSearchParams: ISearchParams<TSearchFacets> = {
	textSearch: null,
	facetsData: {
		post_type_label: ['Posts'],
		'taxonomies.category': [],
		'taxonomies.topic': [],
	},
	perPage: 11,
};
let showResults = false;
let searchService: SearchService<TSearchFacets, IDefaultSearchResult>;
let loadedResults: string[] = [];

const $container = $(resourceFilterComponent);
const $resultsContainer = $('[data-search-results]', $container);
const $topicFilter = $('[data-topic-filter]', $container);
const $resourceTypeFilter = $('[data-resource-type-filter]', $container);
const $keywordSearch = $(filterKeywordSearch, $container);
const $featuredEvent = $('.filter_listing-featured', $container);
const $searchStatusContainer = $('.filter_listing-status_container', $container);
const $searchCount = $('[data-search-resources-search-count]', $container);
const $searchFacetsApplied = $('[data-search-resources-facets-applied]', $container);
const $searchPagination = $(paginationComponent, $container);

export function initResourceFilter() {
	let isInitialised = false;

	if (!isInitialised) {
		searchService = new SearchService<TSearchFacets, IDefaultSearchResult>({
			indexName: algolia.indices.searchable_posts.name,
			defaultSearchParams,
		});

		if ($topicFilter.length) {
			new FacetSelect($topicFilter, searchService, 'taxonomies.topic', 'facet_dropdown');
		}

		if ($resourceTypeFilter.length) {
			new FacetSelect(
				$resourceTypeFilter,
				searchService,
				'taxonomies.category',
				'facet_dropdown',
			);
		}

		if ($keywordSearch.length) {
			new SearchKeyword(
				$keywordSearch as JQuery<HTMLInputElement>,
				searchService,
				handleKeywordSearch,
			);
		}

		if ($searchCount.length) {
			new SearchCount($searchCount, searchService, '{####} resources found');
		}

		if ($searchFacetsApplied.length) {
			new FacetApplied($searchFacetsApplied, searchService);
		}

		if ($searchPagination.length) {
			new Pagination($searchPagination, searchService);
		}

		searchService.addResultsListener((results) => {
			// Reset the loadedResults if new search
			if (searchService.currentPage === 0) {
				loadedResults = [];
			}

			if ($resultsContainer.length) {
				displayResults($resultsContainer, results);
			}
		});

		initSearch();

		isInitialised = true;
	}
}

function displayResults(
	$resultsContainer: JQuery<HTMLElement>,
	results: SearchResponse<IDefaultSearchResult>,
) {
	let content = '';
	let animationDelay = 0;

	if (results && results.hits.length) {
		content = results.hits
			.map((hit) => {
				if (loadedResults.indexOf(hit.objectID) < 0) {
					loadedResults.push(hit.objectID);
					++animationDelay;
				}

				return `
					<div class="tile">
						${hit.tile_render}
					</div>
				`;
			})
			.join('');
	} else {
		const noResultsText = 'No results matching your search criteria';
		content = `<span class="filter-no-results">${noResultsText}</span>`;
	}

	const facets = searchService.getUserFacets();

	if (hasFacetsApplied(facets)) {
		toggleFeatured(true);
	} else {
		toggleFeatured(false);
	}

	$resultsContainer.empty().append(content);

	updateLanguageLinks();

	$container.get(0).scrollIntoView();
}

function toggleFeatured(show: boolean) {
	if (show) {
		$searchStatusContainer.addClass('filter_listing-status_container--show');
		$featuredEvent.addClass('filter_listing-featured--hide');
		$featuredEvent.delay(400).slideUp();
	} else {
		$featuredEvent.slideDown();

		setTimeout(() => {
			$featuredEvent.removeClass('filter_listing-featured--hide');
			$searchStatusContainer.removeClass('filter_listing-status_container--show');
		}, 400);
	}
}

function hasFacetsApplied(facets: IFacet[]): boolean {
	let hasFacet = false;

	facets.forEach((facet) => {
		const { facetValue } = facet;

		if (facetValue.length && facet.facetName !== 'post_type_label') {
			hasFacet = true;
		}
	});

	return hasFacet;
}

function handleKeywordSearch(value: string) {
	if (searchService) {
		if (value !== '') {
			showResults = true;
		}

		const newParams = searchService.searchParams;
		newParams.textSearch = value;
		searchService.searchParams = newParams;
	}
}
function handleClearValue() {
	let newParams = searchService.searchParams;
	newParams.facetsData['taxonomies.product_cat'] = [];
	searchService.searchParams = newParams;
}

function initSearch() {
	if (searchService) {
		const newParams = searchService.searchParams;
		newParams.textSearch = '';
		searchService.searchParams = newParams;
	}
}



// WEBPACK FOOTER //
// ./scripts/components/resourceFilter.ts